/**
 * Pure visual helpers for GitHub PR cards (kept CC ≤ 4 for CRAP gate).
 */

import type { AttentionItem } from '../../domain/types';

const STATUS_ACCENT: Record<string, string> = {
  blocked: 'repeating-linear-gradient(135deg, var(--z-bad) 0 3px, transparent 3px 6px)',
  you: 'var(--z-warn)',
  ready: 'repeating-linear-gradient(0deg, var(--z-ok) 0 5px, transparent 5px 6px)',
};

export function githubAccentStripBackground(item: AttentionItem): string {
  if (item.merged) return 'var(--z-ok)';
  return STATUS_ACCENT[item.st] ?? 'var(--z-dim)';
}

export function githubMergeBoxBackground(item: AttentionItem): string {
  if (isMergeSuccessState(item)) return 'var(--z-ok-bg)';
  if (item.st === 'blocked') return 'var(--z-bad-bg)';
  return 'var(--z-fill)';
}

export function githubMergeStatusColor(item: AttentionItem): string {
  if (isMergeSuccessState(item)) return 'var(--z-ok)';
  if (item.st === 'blocked') return 'var(--z-bad)';
  return 'var(--z-warn)';
}

export function githubMergeStatusGlyph(item: AttentionItem): string {
  if (isMergeSuccessState(item)) return '✓';
  if (item.st === 'blocked') return '×';
  return '!';
}

export function githubPrBadgeLabel(item: AttentionItem): string {
  if (item.mergeTitle) return item.mergeTitle;
  return item.merged ? 'Merged' : 'PR';
}

export function isMergeSuccessState(item: AttentionItem): boolean {
  return Boolean(item.merged || item.st === 'ready');
}
